import type * as Types from '../../../../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetBudgetWidgetsDataQueryVariables = Types.Exact<{
  yesterdayStart: Types.Scalars['Date']['input'];
  yesterdayEnd: Types.Scalars['Date']['input'];
  dayBeforeYesterdayStart: Types.Scalars['Date']['input'];
  dayBeforeYesterdayEnd: Types.Scalars['Date']['input'];
  monthStart: Types.Scalars['Date']['input'];
  monthEnd: Types.Scalars['Date']['input'];
  prevMonthStart: Types.Scalars['Date']['input'];
  prevMonthEnd: Types.Scalars['Date']['input'];
  currentMonthStart: Types.Scalars['Date']['input'];
  currentMonthEnd: Types.Scalars['Date']['input'];
  previousMonthStart: Types.Scalars['Date']['input'];
  previousMonthEnd: Types.Scalars['Date']['input'];
}>;


export type GetBudgetWidgetsDataQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly currentCompany?: { readonly __typename?: 'AccountsCompany', readonly unfinishedMediaplans: ReadonlyArray<{ readonly __typename?: 'AccountsMediaplan', readonly id: string, readonly startOn: string, readonly endOn?: string | null, readonly type: Types.AccountsMediaplanType, readonly repeat?: Types.AccountsMediaplanRepeat | null, readonly startOnPeriodBegin?: boolean | null, readonly budget: number, readonly kpis?: ReadonlyArray<{ readonly __typename?: 'AccountsKpi', readonly primary: boolean, readonly name: Types.AccountsKpiName, readonly value: string | number }> | null }>, readonly yesterdayStats: ReadonlyArray<{ readonly __typename?: 'YalperGraphStat', readonly cpc: number, readonly currency: string, readonly spent: number, readonly platform: Types.YalperPlatform, readonly extendedPlatform: Types.YalperExtendedPlatform }>, readonly dayBeforeYesterdayStats: ReadonlyArray<{ readonly __typename?: 'YalperGraphStat', readonly cpc: number, readonly currency: string, readonly spent: number, readonly platform: Types.YalperPlatform, readonly extendedPlatform: Types.YalperExtendedPlatform }>, readonly monthStats: ReadonlyArray<{ readonly __typename?: 'YalperGraphStat', readonly cpc: number, readonly currency: string, readonly spent: number, readonly platform: Types.YalperPlatform, readonly extendedPlatform: Types.YalperExtendedPlatform }>, readonly prevMonthStats: ReadonlyArray<{ readonly __typename?: 'YalperGraphStat', readonly cpc: number, readonly currency: string, readonly spent: number, readonly platform: Types.YalperPlatform, readonly extendedPlatform: Types.YalperExtendedPlatform }>, readonly currentMonthBudgetStats: { readonly __typename?: 'EfficiencyBudgetData', readonly totalSpent: string | number, readonly uneffectiveSpent: string | number }, readonly previousMonthBudgetStats: { readonly __typename?: 'EfficiencyBudgetData', readonly totalSpent: string | number, readonly uneffectiveSpent: string | number }, readonly graphStatsForSavings: ReadonlyArray<{ readonly __typename?: 'YalperGraphStat', readonly currency: string }> } | null } | null };

export type GetHotspotSettingsQueryVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  startDate: Types.Scalars['Date']['input'];
  endDate: Types.Scalars['Date']['input'];
}>;


export type GetHotspotSettingsQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly currentCompany?: { readonly __typename?: 'AccountsCompany', readonly funnelSettings: { readonly __typename?: 'YalperFunnelSettings', readonly goals: ReadonlyArray<{ readonly __typename?: 'YalperFunnelGoal', readonly id: number }> }, readonly hotspotsState?: { readonly __typename?: 'AccountsHotspotsState', readonly mediaplanHideAt?: string | null, readonly funnelHideAt?: string | null, readonly feedHideAt?: string | null, readonly sensorsHideAt?: string | null, readonly sensorsTouched?: boolean | null } | null, readonly mediaplans: ReadonlyArray<{ readonly __typename?: 'AccountsMediaplan', readonly id: string }> } | null, readonly company?: { readonly __typename?: 'AccountsCompany', readonly trackingFeeds?: ReadonlyArray<{ readonly __typename?: 'YalperTrackingFeedsFeed', readonly id: number }> | null } | null, readonly subscription: { readonly __typename?: 'YalperSubscription', readonly planId?: number | null, readonly endDate?: string | null, readonly isTrial: boolean } } | null };


export const GetBudgetWidgetsDataDocument = gql`
    query GetBudgetWidgetsData($yesterdayStart: Date!, $yesterdayEnd: Date!, $dayBeforeYesterdayStart: Date!, $dayBeforeYesterdayEnd: Date!, $monthStart: Date!, $monthEnd: Date!, $prevMonthStart: Date!, $prevMonthEnd: Date!, $currentMonthStart: Date!, $currentMonthEnd: Date!, $previousMonthStart: Date!, $previousMonthEnd: Date!) {
  currentUser {
    currentCompany {
      unfinishedMediaplans {
        id
        startOn
        endOn
        type
        repeat
        startOnPeriodBegin
        budget
        kpis {
          primary
          name
          value
        }
      }
      yesterdayStats: graphStats(startDate: $yesterdayStart, endDate: $yesterdayEnd) {
        cpc
        currency
        spent
        platform
        extendedPlatform
      }
      dayBeforeYesterdayStats: graphStats(
        startDate: $dayBeforeYesterdayStart
        endDate: $dayBeforeYesterdayEnd
      ) {
        cpc
        currency
        spent
        platform
        extendedPlatform
      }
      monthStats: graphStats(startDate: $monthStart, endDate: $monthEnd) {
        cpc
        currency
        spent
        platform
        extendedPlatform
      }
      prevMonthStats: graphStats(startDate: $prevMonthStart, endDate: $prevMonthEnd) {
        cpc
        currency
        spent
        platform
        extendedPlatform
      }
      currentMonthBudgetStats: budgetEfficiency(
        startDate: $currentMonthStart
        endDate: $currentMonthEnd
      ) {
        totalSpent
        uneffectiveSpent
      }
      previousMonthBudgetStats: budgetEfficiency(
        startDate: $previousMonthStart
        endDate: $previousMonthEnd
      ) {
        totalSpent
        uneffectiveSpent
      }
      graphStatsForSavings: graphStats(
        startDate: $currentMonthStart
        endDate: $currentMonthEnd
      ) {
        currency
      }
    }
  }
}
    `;

/**
 * __useGetBudgetWidgetsDataQuery__
 *
 * To run a query within a React component, call `useGetBudgetWidgetsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBudgetWidgetsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBudgetWidgetsDataQuery({
 *   variables: {
 *      yesterdayStart: // value for 'yesterdayStart'
 *      yesterdayEnd: // value for 'yesterdayEnd'
 *      dayBeforeYesterdayStart: // value for 'dayBeforeYesterdayStart'
 *      dayBeforeYesterdayEnd: // value for 'dayBeforeYesterdayEnd'
 *      monthStart: // value for 'monthStart'
 *      monthEnd: // value for 'monthEnd'
 *      prevMonthStart: // value for 'prevMonthStart'
 *      prevMonthEnd: // value for 'prevMonthEnd'
 *      currentMonthStart: // value for 'currentMonthStart'
 *      currentMonthEnd: // value for 'currentMonthEnd'
 *      previousMonthStart: // value for 'previousMonthStart'
 *      previousMonthEnd: // value for 'previousMonthEnd'
 *   },
 * });
 */
export function useGetBudgetWidgetsDataQuery(baseOptions: Apollo.QueryHookOptions<GetBudgetWidgetsDataQueryPage, GetBudgetWidgetsDataQueryVariables> & ({ variables: GetBudgetWidgetsDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBudgetWidgetsDataQueryPage, GetBudgetWidgetsDataQueryVariables>(GetBudgetWidgetsDataDocument, options);
      }
export function useGetBudgetWidgetsDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBudgetWidgetsDataQueryPage, GetBudgetWidgetsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBudgetWidgetsDataQueryPage, GetBudgetWidgetsDataQueryVariables>(GetBudgetWidgetsDataDocument, options);
        }
export function useGetBudgetWidgetsDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBudgetWidgetsDataQueryPage, GetBudgetWidgetsDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBudgetWidgetsDataQueryPage, GetBudgetWidgetsDataQueryVariables>(GetBudgetWidgetsDataDocument, options);
        }
export type GetBudgetWidgetsDataQueryHookResult = ReturnType<typeof useGetBudgetWidgetsDataQuery>;
export type GetBudgetWidgetsDataLazyQueryHookResult = ReturnType<typeof useGetBudgetWidgetsDataLazyQuery>;
export type GetBudgetWidgetsDataSuspenseQueryHookResult = ReturnType<typeof useGetBudgetWidgetsDataSuspenseQuery>;
export type GetBudgetWidgetsDataQueryResult = Apollo.QueryResult<GetBudgetWidgetsDataQueryPage, GetBudgetWidgetsDataQueryVariables>;
export const GetHotspotSettingsDocument = gql`
    query GetHotspotSettings($companyId: ID!, $startDate: Date!, $endDate: Date!) {
  currentUser {
    currentCompany {
      funnelSettings {
        goals {
          id
        }
      }
      hotspotsState {
        mediaplanHideAt
        funnelHideAt
        feedHideAt
        sensorsHideAt
        sensorsTouched
      }
      mediaplans(endDate: $endDate, startDate: $startDate) {
        id
      }
    }
    company(id: $companyId) {
      trackingFeeds {
        id
      }
    }
    subscription {
      planId
      endDate
      isTrial
    }
  }
}
    `;

/**
 * __useGetHotspotSettingsQuery__
 *
 * To run a query within a React component, call `useGetHotspotSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHotspotSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHotspotSettingsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetHotspotSettingsQuery(baseOptions: Apollo.QueryHookOptions<GetHotspotSettingsQueryPage, GetHotspotSettingsQueryVariables> & ({ variables: GetHotspotSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHotspotSettingsQueryPage, GetHotspotSettingsQueryVariables>(GetHotspotSettingsDocument, options);
      }
export function useGetHotspotSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHotspotSettingsQueryPage, GetHotspotSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHotspotSettingsQueryPage, GetHotspotSettingsQueryVariables>(GetHotspotSettingsDocument, options);
        }
export function useGetHotspotSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHotspotSettingsQueryPage, GetHotspotSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHotspotSettingsQueryPage, GetHotspotSettingsQueryVariables>(GetHotspotSettingsDocument, options);
        }
export type GetHotspotSettingsQueryHookResult = ReturnType<typeof useGetHotspotSettingsQuery>;
export type GetHotspotSettingsLazyQueryHookResult = ReturnType<typeof useGetHotspotSettingsLazyQuery>;
export type GetHotspotSettingsSuspenseQueryHookResult = ReturnType<typeof useGetHotspotSettingsSuspenseQuery>;
export type GetHotspotSettingsQueryResult = Apollo.QueryResult<GetHotspotSettingsQueryPage, GetHotspotSettingsQueryVariables>;